import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { useContext } from "react";
import { providerProfilePath } from "@app/projects/network-assessment/provider-hub/providerHubProfilePaths";

export const useProviderLink = () => {
  const projectContext = useContext(CountyProjectContext);

  return (servicingProviderKey: string): string => `${window.customUIBaseUrl}${providerProfilePath(projectContext.project.projectId, projectContext.runConfiguration.projectRunConfigurationId, servicingProviderKey)}`;
}
